var map = {
	"./ic-alert-red.svg": "0l3P",
	"./ic-alert.svg": "SZLR",
	"./ic-arrow-down.svg": "6b1D",
	"./ic-bct.svg": "Y5ML",
	"./ic-contact-tracer.inline.svg": "bUI/",
	"./ic-contact-tracing.svg": "bF5A",
	"./ic-download.svg": "/aes",
	"./ic-error.svg": "zp96",
	"./ic-immunity-passport.svg": "/4Ak",
	"./ic-language.svg": "yFVW",
	"./ic-logout.svg": "6lZS",
	"./ic-menu-employee-disabled.svg": "AMP9",
	"./ic-menu-employee-hover.svg": "5iTN",
	"./ic-menu-employee-pressed.svg": "ndW7",
	"./ic-menu-employee.svg": "ddEI",
	"./ic-menu-facilities-disabled.svg": "fja5",
	"./ic-menu-facilities-hover.svg": "zIZt",
	"./ic-menu-facilities-pressed.svg": "l8Al",
	"./ic-menu-facilities.svg": "1W+X",
	"./ic-menu-immunity-passport-disabled.svg": "tC0m",
	"./ic-menu-immunity-passport-hover.svg": "ZeyJ",
	"./ic-menu-immunity-passport-pressed.svg": "71xP",
	"./ic-menu-immunity-passport.svg": "Isxu",
	"./ic-menu-information-disabled.svg": "+3eo",
	"./ic-menu-information-hover.svg": "InoV",
	"./ic-menu-information-pressed.svg": "TFzs",
	"./ic-menu-information.svg": "rf9H",
	"./ic-success.svg": "et3T",
	"./ic-survey.svg": "kKVp",
	"./ic-verified-error.svg": "ay7Z",
	"./ic-warning.svg": "vqil",
	"./ic-workspace.svg": "p39n"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nD1l";